class DesktopMenu extends HTMLElement {
    constructor() {
        super();
        this.overlay = document.querySelector('#page-blur-overlay');
        this.enjpHeader = document.querySelectorAll('.tw-enjp-header');
        this.triggers = Array.from(document.querySelectorAll('[data-mega-trigger]'));
        this.menuNav = document.querySelector('[data-menu-nav]');

        // bind dei handler per poterli rimuovere dopo
        this.handleMenuHover = this.handleMenuHover.bind(this);
        this.handleMenuLeave = this.handleMenuLeave.bind(this);
        this.handlePanelEnter = this.handlePanelEnter.bind(this);
        this.handlePanelLeave = this.handlePanelLeave.bind(this);
        this.handleMouseLeaveMenu = this.handleMouseLeaveMenu.bind(this);
    }

    connectedCallback() {
        this.header = document.querySelector('.header');
        if (!this.header) return;

        // Riferimento ai pannelli mega (array)
        this.panels = Array.from(this.querySelectorAll('.mega-panel'));

        // Attacca listener ai trigger (una sola volta)
        this.triggers.forEach(link => {
            link.addEventListener('mouseenter', this.handleMenuHover);
            link.addEventListener('mouseleave', this.handleMenuLeave);
        });

        // Attacca listener ai pannelli (una sola volta)
        this.panels.forEach(panel => {
            panel.addEventListener('mouseenter', this.handlePanelEnter);
            panel.addEventListener('mouseleave', this.handlePanelLeave);
        });

        // Quando si esce dal mega menu intero
        this.addEventListener('mouseleave', this.handleMouseLeaveMenu);
    }

    handleMenuHover(e) {
        const trigger = e.currentTarget;
        const title = trigger.getAttribute('data-mega-trigger');

        // Rimuove l'attributo 'active' da tutti i trigger (coerenza)
        this.triggers.forEach(t => t.removeAttribute('active'));

        // Imposta active sul trigger corrente
        trigger.setAttribute('active', '');

        // Mostra overlay e header
        this.classList.remove('tw-hidden');
        this.enjpHeader?.forEach(el => el.classList.add('menu-open'));
        this.overlay?.classList.remove('tw-hidden');

        // Aggiorna il mega panel visibile
        this.updateMegaContent(title);
    }

    handleMenuLeave(e) {
        const trigger = e.currentTarget;
        const related = e.relatedTarget;
        const title = trigger.getAttribute('data-mega-trigger');
        const panel = this.querySelector(`.mega-panel[data-mega-title="${title}"]`);

        // se il mouse va nel panel relativo, non rimuovere active
        if (panel && panel.contains(related)) return;

        // se va verso un altro trigger, il nuovo trigger gestirà lo switch: non forzare qui
        if (related && related.closest && related.closest('[data-mega-trigger]')) return;

        // altrimenti rimuovi active e controlla se chiudere il menu
        trigger.removeAttribute('active');

        if (!this.menuNav.contains(related) && !this.contains(related)) {
            this.closeMegaMenu();
        }
    }

    handlePanelEnter(e) {
        const panel = e.currentTarget;
        const title = panel.getAttribute('data-mega-title');
        const trigger = this.triggers.find(t => t.getAttribute('data-mega-trigger') === title);
        if (trigger) trigger.setAttribute('active', '');
    }

    handlePanelLeave(e) {
        const panel = e.currentTarget;
        const related = e.relatedTarget;
        const title = panel.getAttribute('data-mega-title');

        // se si va su un trigger, non rimuovere (il trigger si occuperà di switchare)
        if (related && related.closest && related.closest('[data-mega-trigger]')) return;

        const trigger = this.triggers.find(t => t.getAttribute('data-mega-trigger') === title);
        if (trigger) trigger.removeAttribute('active');

        if (!this.menuNav.contains(related) && !this.contains(related)) {
            this.closeMegaMenu();
        }
    }

    handleMouseLeaveMenu(e) {
        const related = e.relatedTarget;
        if (!this.menuNav.contains(related) && !this.contains(related)) {
            // rimuovi tutti e chiudi
            this.triggers.forEach(t => t.removeAttribute('active'));
            this.closeMegaMenu();
        }
    }

    updateMegaContent(title) {
        if (!this) return;

        const panels = this.querySelectorAll('.mega-panel');
        panels.forEach(panel => {
            if (panel.getAttribute('data-mega-title') === title)
                panel.classList.remove('tw-hidden');
            else
                panel.classList.add('tw-hidden');
        });
    }

    closeMegaMenu() {
        this.classList.add('tw-hidden');
        this.overlay?.classList.add('tw-hidden');
        this.enjpHeader?.forEach(el => el.classList.remove('menu-open'));
    }

    disconnectedCallback() {
        // rimuovi tutti i listener aggiunti
        this.triggers.forEach(link => {
            link.removeEventListener('mouseenter', this.handleMenuHover);
            link.removeEventListener('mouseleave', this.handleMenuLeave);
        });
        this.panels.forEach(panel => {
            panel.removeEventListener('mouseenter', this.handlePanelEnter);
            panel.removeEventListener('mouseleave', this.handlePanelLeave);
        });
        this.removeEventListener('mouseleave', this.handleMouseLeaveMenu);

        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }
}
if (!customElements.get('desktop-menu')) {
    customElements.define('desktop-menu', DesktopMenu);
}


class MobileMenu extends DesktopMenu {
    constructor() {
        super();
        this._state = {
            isOpen: false,
            currentSubmenu: null,
        };
    }

    connectedCallback() {
        this.trigger = document.querySelector('[data-mobile-menu-trigger]');
        this.hamburgerIcon = this.trigger?.querySelector('.hamburger-icon');
        this.closeIcon = this.trigger?.querySelector('.close-icon');
        this.mainMenu = this.querySelector('.menu-main');
        this.stickyFilter = document.getElementById("sticky-filter");

        // Inizializza max-height per le sezioni aperte di default
        this.querySelectorAll('[data-section-content]').forEach(content => {
            content.style.maxHeight = content.scrollHeight + "px";
        });

        // Listener per il pulsante hamburger (trigger diretto)
        this.trigger?.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle();
        });

        // Event delegation solo per gli elementi INTERNI al menu
        this.addEventListener('click', (e) => {
            const submenuTrigger = e.target.closest('[data-submenu-trigger]');
            const backBtn = e.target.closest('.submenu-back');
            const sectionToggle = e.target.closest('[data-section-toggle]');

            if (submenuTrigger) {
                e.preventDefault();
                this.openSubmenu(submenuTrigger.dataset.submenuTrigger);
            } else if (backBtn) {
                e.preventDefault();
                this.closeSubmenu();
            } else if (sectionToggle) {
                e.preventDefault();
                this.toggleSection(sectionToggle);
            }
        });

        // Chiudi con Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (this._state.currentSubmenu) {
                    this.closeSubmenu();
                } else if (this._state.isOpen) {
                    this.close();
                }
            }
        });
        subscribe(PUB_SUB_EVENTS.onToggleSearch, (msg, data) => {
            this.close();
        });
        this._setupMediaQueryListener();

    }
    disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.toggle);
        document.removeEventListener('keydown', this._handleKeydown);
        this._mediaQuery?.removeEventListener('change', this._handleMediaQueryChange);
    }
    _setupMediaQueryListener() {
        this._mediaQuery = window.matchMedia('(min-width: 1024px)');
        this._handleMediaQueryChange = (e) => {
            if (e.matches && this._state.isOpen) {
                this.close();
            }
        };
        this._mediaQuery.addEventListener('change', this._handleMediaQueryChange);
        // Esegui una volta all'inizio
        if (this._mediaQuery.matches && this._state.isOpen) {
            this.close();
        }
    }
    open() {
        this.classList.remove('tw-translate-x-full');
        this.hamburgerIcon?.classList.add('tw-hidden');
        this.enjpHeader?.forEach(el => {
            el.classList.add('menu-open');
        });
        this.closeIcon?.classList.remove('tw-hidden');
        document.body.classList.add('overflow-hidden');

        // Nascondi sticky-filter con animazione
        if (this.stickyFilter) {
            this.stickyFilter.classList.add('tw-transition-opacity', 'tw-duration-300', 'tw-opacity-0');
            setTimeout(() => {
                this.stickyFilter.classList.add('tw-hidden');
                this.stickyFilter.classList.remove('tw-opacity-0', 'tw-transition-opacity', 'tw-duration-300');
            }, 300);
        }

        this._state.isOpen = true;
        this.setAttribute('aria-expanded', 'true');
        publish(PUB_SUB_EVENTS.onOpenMenu, {
            isOpen: true
        });
    }


    close() {
        this.classList.add('tw-translate-x-full');
        this.hamburgerIcon?.classList.remove('tw-hidden');
        this.closeIcon?.classList.add('tw-hidden');
        this.enjpHeader?.forEach(el => {
            el.classList.remove('menu-open');
        });
        document.body.classList.remove('overflow-hidden');

        // Mostra sticky-filter con animazione
        if (this.stickyFilter) {
            this.stickyFilter.classList.remove('tw-hidden');
            this.stickyFilter.classList.add('tw-transition-opacity', 'tw-duration-300', 'tw-opacity-0');
            // Forza un reflow per far partire l'animazione
            void this.stickyFilter.offsetWidth;
            this.stickyFilter.classList.remove('tw-opacity-0');
            setTimeout(() => {
                this.stickyFilter.classList.remove('tw-transition-opacity', 'tw-duration-300');
            }, 300);
        }

        this._state.isOpen = false;
        this.setAttribute('aria-expanded', 'false');
    }


    toggle() {
        this._state.isOpen ? this.close() : this.open();
    }

    openSubmenu(submenuName) {
        const submenuPanel = this.querySelector(`[data-submenu-panel="${submenuName}"]`);
        if (!submenuPanel) return;

        this.mainMenu.classList.add('-tw-translate-x-full');
        submenuPanel.classList.remove('tw-translate-x-full');
        submenuPanel.setAttribute('aria-hidden', 'false');
        this._state.currentSubmenu = submenuName;
    }

    closeSubmenu() {
        const currentSubmenu = this.getCurrentSubmenu();
        if (!currentSubmenu) return;

        currentSubmenu.classList.add('tw-translate-x-full');
        currentSubmenu.setAttribute('aria-hidden', 'true');
        this.mainMenu.classList.remove('-tw-translate-x-full');
        this._state.currentSubmenu = null;
    }

    getCurrentSubmenu() {
        return this.querySelector('.submenu-panel:not(.tw-translate-x-full)');
    }

    toggleSection(toggle) {
        const content = toggle.nextElementSibling;
        const arrow = toggle.querySelector('.section-arrow');
        const isExpanded = content.style.maxHeight && content.style.maxHeight !== '0px';

        arrow.classList.toggle('tw-rotate-180');
        content.style.maxHeight = isExpanded ? '0px' : content.scrollHeight + "px";
        toggle.setAttribute('aria-expanded', !isExpanded);
    }
}

customElements.define('mobile-menu', MobileMenu);
